import React from 'react'
import { Label } from 'shared/ui'
import ManagedAccordion from 'shared/components/ui/ManagedAccordion'
import { extractSpecificFields } from 'ducks/integrations/shared/settings'
import { Menu } from 'util/ui'

import { Section, SectionLabel } from './Section'

import Row from './Row'
import Key from './Key'

export default class Deals extends React.PureComponent {
  render() {
    const { dealsObject, settings, ownersById } = this.props
    const specificFields = extractSpecificFields(
      settings,
      /showSidebarField.Deal\./
    )
    if (!dealsObject) return null
    if (dealsObject.state !== 'fetched') return null
    if (dealsObject.state === 'fetched' && dealsObject.deals.length === 0) {
      return null
    }

    return (
      <Section>
        <SectionLabel size="small" as="div">
          Deals
        </SectionLabel>
        {dealsObject &&
          dealsObject.state === 'fetched' && (
            <React.Fragment>
              {dealsObject.deals.map(deal => (
                <ManagedAccordion
                  key={`deal-${deal.id}`}
                  as={Menu}
                  fluid
                  initiallyActive={false}
                  styled
                  title={
                    <Label size="small">
                      {deal.properties.dealname &&
                        deal.properties.dealname.value}
                    </Label>
                  }
                  vertical
                >
                  <React.Fragment>
                    {(specificFields || Object.keys(deal.properties)).map(
                      key => {
                        const property = deal.properties[key]
                        if (!property) return null
                        let value = property.value
                        if (property.key.match('hubspot_owner_id')) {
                          const ownerId = property.value
                          const owner =
                            ownerId && ownersById && ownersById[ownerId]
                          if (owner) value = owner.label
                        }

                        return (
                          <Row>
                            <Key>{property.label}: </Key>
                            {value}
                          </Row>
                        )
                      }
                    )}
                  </React.Fragment>
                </ManagedAccordion>
              ))}
            </React.Fragment>
          )}
      </Section>
    )
  }
}
